export const clsx = (...args) => {
  return args.reduce((acc, el) => {
    return acc + " " + `${el}`;
  }, "");
};
